export var EExecutor = /*#__PURE__*/function (EExecutor) {
  EExecutor["user"] = "user";
  EExecutor["system"] = "system";
  return EExecutor;
}(EExecutor || {});